import { Box, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { TableImgComponent } from "components/PimDashboard/DashboardComponents/Designer/CreateStyle/ColorsSection/ColorsSection";
import { formatColumnValue } from "components/PimDashboard/data";
import { sourcingOptionCogsColumn, sourcingOptionCogsRemarkColumn } from "components/PimDashboard/DashboardComponents/Sourcing/FabricStylesDashboard/EditFabricStyleDetails/data";

const ROW_HEIGHT = 58;
const MIN_VISIBLE_ROWS = 4;
const MAX_VISIBLE_ROWS = 5;

const formatCogs = (value) => {
	if (value === "" || value == null) return "-";
	return formatColumnValue(value, sourcingOptionCogsColumn);
};

const formatRemark = (value) => {
	const text = `${value ?? ""}`.trim();
	return text || "-";
};

const ColorPaletteCogsTable = ({ colors = [] }) => {
	const rows = Array.isArray(colors) ? colors : [];
	const scrollable = rows.length > MAX_VISIBLE_ROWS;

	return (
		<Box
			sx={{
				width: "100%",
				minWidth: 0,
				border: `1px solid ${grey[200]}`,
				borderRadius: 1.5,
				bgcolor: grey[50],
				overflow: "hidden",
				display: "flex",
				flexDirection: "column",
			}}>
			<Typography
				variant="caption"
				fontWeight={700}
				sx={{
					flexShrink: 0,
					px: 1.25,
					py: 0.75,
					color: grey[700],
					borderBottom: `1px solid ${grey[200]}`,
					bgcolor: "#fff",
					letterSpacing: "0.04em",
					textTransform: "uppercase",
				}}>
				Color / Palette / COGS / Remark
			</Typography>

			<Box
				sx={{
					bgcolor: "#fff",
					minHeight: ROW_HEIGHT * MIN_VISIBLE_ROWS,
					maxHeight: ROW_HEIGHT * MAX_VISIBLE_ROWS,
					overflowY: scrollable ? "auto" : "hidden",
					overflowX: "hidden",
				}}>
				{rows.length ? (
					rows.map((row, index) => {
						const palette = row?.palette ?? row?.pallete ?? "-";
						const rowKey = row?.id ?? row?.option_id ?? `${row?.color ?? "color"}-${index}`;

						return (
							<Box
								key={rowKey}
								sx={{
									display: "flex",
									alignItems: "center",
									gap: 1,
									px: 1.25,
									minHeight: ROW_HEIGHT,
									boxSizing: "border-box",
									borderBottom: index < rows.length - 1 ? `1px solid ${grey[100]}` : "none",
								}}>
								<Box
									sx={{
										width: 34,
										height: 40,
										flexShrink: 0,
										overflow: "hidden",
										borderRadius: 1,
										border: `1px solid ${grey[200]}`,
										"& img": { objectFit: "cover" },
									}}>
									<TableImgComponent data={row} column="url" />
								</Box>

								<Box sx={{ flex: 1, minWidth: 0 }}>
									<Typography
										variant="caption"
										fontWeight={700}
										sx={{
											display: "block",
											color: grey[900],
											lineHeight: 1.25,
											wordBreak: "break-word",
											overflowWrap: "anywhere",
										}}>
										{row?.color || "-"}
									</Typography>
									<Typography
										variant="caption"
										sx={{
											display: "block",
											color: grey[600],
											lineHeight: 1.25,
											wordBreak: "break-word",
											overflowWrap: "anywhere",
										}}>
										{palette || "-"}
									</Typography>
								</Box>

								<Box sx={{ flexShrink: 0, maxWidth: "42%", textAlign: "right" }}>
									<Typography variant="caption" fontWeight={700} sx={{ display: "block", color: grey[800] }}>
										{formatCogs(row?.[sourcingOptionCogsColumn.key])}
									</Typography>
									<Typography
										variant="caption"
										sx={{
											display: "block",
											color: grey[600],
											lineHeight: 1.25,
											wordBreak: "break-word",
											overflowWrap: "anywhere",
										}}>
										{formatRemark(row?.[sourcingOptionCogsRemarkColumn.key])}
									</Typography>
								</Box>
							</Box>
						);
					})
				) : (
					<Box
						sx={{
							minHeight: ROW_HEIGHT * MIN_VISIBLE_ROWS,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							px: 1.25,
						}}>
						<Typography variant="caption" color={grey[500]}>
							No colors
						</Typography>
					</Box>
				)}
			</Box>
		</Box>
	);
};

export default ColorPaletteCogsTable;
